
import React from 'react';
import { useIntl } from 'react-intl';
import styles from './DiscountBanner.module.css';
import { Link } from 'react-router-dom';

const DiscountBanner = (isAuthenticated) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <div className={styles.banner}>
        <h2 className={styles.title}>{intl.formatMessage({ id: 'discountBanner.title' })}</h2>
        {!isAuthenticated ? (
          <Link to="/signup">
            <button className={styles.button}>
              {intl.formatMessage({ id: 'discountBanner.button' })}
            </button>
          </Link>
        ) : (
          <Link to="/s?keywords=">
            <button className={styles.button}>
              {intl.formatMessage({ id: 'OrderPanel.ctaButtonMessageBooking' })}
            </button>
          </Link>
        )}
      </div>
    </div>
  );
};

export default DiscountBanner;
